
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aicopy",
      function () {
        return require("private-next-pages/aicopy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aicopy"])
      });
    }
  